import { prop } from "lodash/fp";
import type { Designer } from "storefront/Designer";
import { get } from "storefront/GrailedAPI/request";

const all: (arg0: void) => Promise<Array<Designer>> = () =>
  get("/api/designers").then(prop("data"));

export default all;
